import { Close } from "@mui/icons-material";
import { SnackbarCloseReason } from "@mui/material/Snackbar";
import AppAlert, { AppAlertProps } from "components/v2/atoms/app-alert/AppAlert";
import AppIconButton, { AppIconButtonProps } from "components/v2/atoms/app-icon-button/AppIconButton";
import AlertCard, { AlertCardProps, variantStyles } from "./AlertCard";

export interface AppCardAlertProps {
    appAlertProps: AppAlertProps;
    alertCardProps?: AlertCardProps;
    showCloseButton?: boolean;
    closeReason?: SnackbarCloseReason;
}

function AppCardAlert(props: AppCardAlertProps) {
    const closeButtonProps: AppIconButtonProps = {
        size: "small",
        children: (
            <Close
                sx={{
                    fontSize: 20,
                    color: variantStyles[props.alertCardProps?.variant ?? "disabled"].color,
                }}
            />
        ),
        onClick(event) {
            props.appAlertProps.onClose?.(event, props.closeReason || "clickaway");
        },
    };

    const alertCardProps: AlertCardProps = {
        ...props.alertCardProps,
        rightSlot: props.showCloseButton ? <AppIconButton {...closeButtonProps} /> : undefined,
    };

    return (
        <AppAlert {...props.appAlertProps}>
            <span style={{ backgroundColor: "white", borderRadius: "6px" }}>
                <AlertCard {...alertCardProps} />
            </span>
        </AppAlert>
    );
}

export default AppCardAlert;
